// Modules
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import moment from 'moment';

// Services
import Ticket from 'services/data/ticket';

// Components
import TicketForm from 'components/models/ticket/forms/ticket-form';
import { SVGButton } from 'components/widgets/buttons/buttons';
import FormPopover from 'components/widgets/overlays/form';
import TicketLink from 'components/models/ticket/ticket-link';
import * as ticketUtils from 'routes/ticket/utils/load-tickets';

// Actions
import { alerts } from 'modules/alerts/actions';


class AddTicketPopup extends React.Component {
  static propTypes = {
    close: PropTypes.func,
    closeOnSubmit: PropTypes.bool,
    onSubmit: PropTypes.func,
    currentUser: PropTypes.object.isRequired
  };

  constructor() {
    super();
    this.createTicket = this.createTicket.bind(this);
  }

  createTicket(values) {
    const newTicket = {
      ...values,
      tasks: [{
        description: 'Task out',
        assignedTo: [{ id: this.props.currentUser.id }],
        dueDate: moment().startOf('day').toDate(),
        priority: 'Critical'
      }]
    };

    Ticket.create(newTicket)
      .then((ticket) =>
        alerts.success({
          title: 'Ticket added!',
          subtitle: <TicketLink ticket={ticket}>View ticket</TicketLink>
        })
      )
      .then(this.addForm.toggle) // Close the form
      .then(ticketUtils.loadTicketsExternal)
      .catch(alerts.catchError);
  }

  render() {
    return (
      <div className="add-ticket">
        <FormPopover
          target={<SVGButton src="svg/add.svg" className="add-item-link" />}
          title="Add Ticket"
          popoverClassName="ticket-form"
          ref={(el) => { this.addForm = el; }}
        >
          <TicketForm
            onSubmit={this.createTicket}
            initialValues={{ type: 'Help Desk', expectedCompletion: new Date() }}
            form="ticketForm-new"
            close={() => {
              if (this.addForm) this.addForm.toggle();
            }}
          />
        </FormPopover>
      </div>
    );
  }
}

export default connect((state) => ({
  currentUser: state.auth.currentUser
}))(AddTicketPopup);
